export function isMemberImportMappingResponse(value) {
    if (typeof value !== 'object' || value === null)
        return false;
    const item = value;
    return (typeof item.sourceSheet === 'string' &&
        Number.isInteger(item.headerRow) &&
        Number(item.headerRow) > 0 &&
        Number.isInteger(item.dataRowCount) &&
        Number(item.dataRowCount) >= 0 &&
        typeof item.generatedAt === 'string' &&
        !Number.isNaN(Date.parse(item.generatedAt)) &&
        Array.isArray(item.mappings) &&
        item.mappings.every((mapping) => typeof mapping.id === 'string' &&
            typeof mapping.sourceField === 'string' &&
            typeof mapping.targetField === 'string' &&
            typeof mapping.originalValue === 'string' &&
            typeof mapping.normalizedValue === 'string' &&
            Number.isInteger(mapping.occurrences) &&
            mapping.occurrences >= 0 &&
            ['text', 'status', 'boolean', 'empty'].includes(mapping.transformation)));
}
